/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import useForm from "../../../hooks/useForm";
import { requiredFieldDefault, textFieldDefault } from "../../../services/validationRules";
import ValidatorTextField from "../../Validator/ValidatorTextField";
import ValidatorForm from "../../Validator/ValidatorForm";
import SubmitButton from "../../Button/SubmitButton";
import _ from "lodash";
import { Box } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const Job = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const initialValues = {
    job: pcs.job,
  };

  const { values, errors, handleChange, handleSubmit, handleBlur, registerValidators, touchedValues } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Beruf</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Was ist Ihr aktueller Beruf?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorTextField
              name="job"
              label="Aktueller Beruf"
              value={formValue(values, "job")}
              onChange={handleChange}
              onBlur={handleBlur}
              validators={[...requiredFieldDefault, ...textFieldDefault]}
              registerValidators={registerValidators}
              error={!!errors["job"]}
              helperText={errors["job"]}
            />
          </Grid>
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default Job;
